export default {
  editSuccess: '修改成功',
  week: '周报',
  weeklyMode: '周报模式',
  originalMode: '普通模式',
  outputDesc: '季度产出描述',
  progress: '当前进度',
  risk: '当前风险',
  comments: '备注与评论',
  editWeekly: '编辑周报',
  notes: '备注',
  commentWeekly: '评论周报',
  current: '仅查看当前日期内容',
  all: '查看全部内容',
  quarter: '季度',
  first: '第一',
  second: '第二',
  third: '第三',
  fourth: '第四',
  required: '必填',
  placeholder: '请填写',
  quarters: [
    '第一季度',
    '第二季度',
    '第三季度',
    '第四季度'
  ],
  head: '负责人',
  item: '事项',
  export: '导出',
  currentRisk: '仅查看存在风险',
  exportConfirm: '确认',
  exportCancel: '取消',
  collaborativeUser: '协同负责人',
  originData: '原始',
  checkComment: '查看评论',
  edit: '编辑'
}
